import {
  DestinationListChilds,
  DestinationListItem,
  HistoryItem,
  HotelProperties,
  SelectedRoom
} from '@beds2b-group/reusable-components/dist/types'
import { FC, useEffect, useState } from 'react'
import {
  clearBookingEngineContext,
  useBookingEngineContext
} from '../../../Contexts/EngineDataContext'
import { useNavigate } from 'react-router-dom'
import { GetFormattedUrl } from '../../../utils/urls'
import { useAppConfig } from '../../../Contexts/AppConfigContext'
import { t } from 'i18next'
import { getHotelIntegrationCode, Place } from '../../../utils/utils'
import { AvailableDestinationsList } from '../../../models/HotelInfo'
import hotelUtils from '../../../mocks/hotels'
import moment from 'moment'
import { WidgetWrapper } from '@beds2b-group/reusable-components'
import '../MapModalWrapper'
import { useModal } from '@gluedigital/modal'
import { EngineDestinationTypeHotel, EngineDestinationTypeLocation } from '../../../utils/constants'
import { GoogleMaps } from '../..'
import { useGoogleMapsContext } from '../../../Contexts/GoogleMapsContext'
import { useCart } from '../../../Contexts/CartContexts'
import { notification, Tooltip } from 'antd'
import './WidgetComponent.scss'
import dayjs, { Dayjs } from 'dayjs'
import { regimensFilter, servicesFilter } from '../../../mocks/availabilityBookings'
import { use } from 'echarts'
import { useSessionData } from '../../../Contexts/SessionDataContext'
import { GetAppLanguage } from '../../../RoutesApp'
import { UserCommisionConfiguration } from '../../../models/UserSessionData'
import { ExclamationCircleOutlined, ExclamationOutlined } from '@ant-design/icons'

export type FilterFormData = {
  freeCancel: string
  priceRange: [string | null, string | null]
  sizeRoomRange: [string | null, string | null]
  preferenceBed: string
  services: string[]
  regimens: string[]
}
interface SearchStatusProps {
  value: string
  hasResults: boolean
}

const RelatedItemComponent: FC<{
  item: HotelProperties
  handleSelect: (item: HotelProperties) => void
}> = ({ item, handleSelect }) => {
  // Aquí puedes usar las props `item` y `handleSelect` para renderizar tu componente
  return <div>Related Items</div>
}

const minLength = 3
function SearchStatus({ value, hasResults }: SearchStatusProps) {
  if (hasResults) return null

  if (value.length < minLength)
    return (
      <li className="status short" style={{ margin: 32, listStyle: 'none' }}>
        {t('components.widget.search-status.short')}
      </li>
    )

  return (
    <li className="status no-results" style={{ margin: 32, listStyle: 'none' }}>
      {t('components.widget.search-status.not-results')}
    </li>
  )
}

interface WidgetComponentProps {
  userHistory: Array<HistoryItem>
  searchCoincidences: Array<any>
  availableDestinations: Array<AvailableDestinationsList>
  onGetCoincidences: (value: string) => void
  cleanForm: boolean
}

const WidgetComponent = (props: WidgetComponentProps): JSX.Element => {
  const cartContext = useCart()
  const modal = useModal()
  const navigate = useNavigate()
  const appConfig = useAppConfig()
  const bookingEngineContext = useBookingEngineContext()
  const { onGetCoincidences, searchCoincidences, availableDestinations } = props

  const [countries, setCountries] = useState<Array<DestinationListItem>>([])
  const [initialFrom, setInitialFrom] = useState<Dayjs | null>(null)
  const [initualTo, setInitialTo] = useState<Dayjs | null>(null)
  const [defaultLabel, setDefaultLabel] = useState<string>('')

  const configInSessionStorage = sessionStorage.getItem('app-config')
  const userDataInSessionStorage = JSON.parse(sessionStorage.getItem('user-data') ?? '{}')




  const userData = useSessionData(); // si tienes un hook, si no, sessionStorage

  const selectedCommissionId = userData?.userData?.commissionConfigurationSelected;
  const allCommissionConfigs: UserCommisionConfiguration[] = appConfig?.config?.userCommissionConfiguration ?? [];
  const selectedCommissionConfig = allCommissionConfigs.find(c => c.id === selectedCommissionId);


  const navigationLanguage = GetAppLanguage();


  const regimens = appConfig?.config?.regimes?.map((r: any) => ({
    id: r?.integrationCode,
    name: r?.names?.find((n: any) => n.language === navigationLanguage.toUpperCase())?.value || ''
  })) ?? [];




  const onChangeSearchValue = (value: string) => {
    onGetCoincidences(value)
  }

  const setInitialCountries = (data: Array<AvailableDestinationsList>) => {
    // obtenemos los countries para ponerlos en countries usando setCountries:
    const countryList: Array<DestinationListItem> = data.map((d: AvailableDestinationsList) => {
      return {
        id: d.countryCode,
        label: d.countryName,
        component: <Place place={d.countryName} hotelsNumber={d.cities.length} />
      }
    })

    setCountries(countryList)
  }

  const handleSelectCountry = (id: string): Array<DestinationListItem> => {
    // Este método filtra para el listado de hoteles por el país, mostrando para ese país cuáles son las ciudades que tienen hoteles.
    const country = availableDestinations.find(
      (d: AvailableDestinationsList) => d.countryCode === id
    )

    sessionStorage.setItem('selectedCountryCode', id)

    const cities = Array.from(
      new Map(
        country?.cities.map((c) => [
          c.cityCode,
          {
            id: c.cityCode,
            label: c.cityName,
            component: <Place place={c.cityName} hotelsNumber={c.hotels.length} />
          }
        ])
      ).values()
    ) as Array<DestinationListItem>

    return cities
  }

  const isHotelDisabledByConfig = (hotelCode: string): boolean => {
    if (!selectedCommissionConfig) return true;

    //  Si NO está en la lista → deshabilitado
    return !selectedCommissionConfig.hotelsAffected?.includes(hotelCode);
  }

  const handleSelectRegion = (id: string): Array<DestinationListItem> => {
    var selectedCountryCode = sessionStorage.getItem('selectedCountryCode')
    const country = availableDestinations.find(
      (d: AvailableDestinationsList) => d.countryCode === selectedCountryCode
    )
    const region = country?.cities.find((c) => c.cityCode === id)
    const hotels = region?.hotels.map((h) => {
      const hotelDisabled = isHotelDisabledByConfig(h.hotelCode);
      return {
        id: h.hotelCode,
        label: h.hotelName,
        component: (
          <p
            style={{ margin: 0 }}
            className={hotelDisabled ? 'hotel-disabled' : ''}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              {h.hotelName}

              {hotelDisabled && (
                <Tooltip title={t('components.widget-component.hotel-disabled-by-config')}>
                  <ExclamationCircleOutlined />
                </Tooltip>
              )}
            </span>
          </p>
        )
      }
    }) as Array<DestinationListItem>

    return hotels
  }

  async function handleSelect(id: string, category: string): Promise<DestinationListChilds | null> {
    //Este método se encarga de manejar la selección de un item en el listado de destinos
    var result = null
    if (category === 'countries') {
      // Aquí entra cuando se selecciona un país
      result = {
        category: 'regions',
        items: handleSelectCountry(id),
        header: <h4>{t('components.widget-component.regions')}</h4>
      }
    } else if (category === 'regions') {
      //Aquí entra cuando se selecciona una región
      sessionStorage.setItem('selectedRegionCode', id)

      result = {
        category: 'hotels',
        items: handleSelectRegion(id),
        header: <h4>{t('components.widget-component.hotels')}</h4>
      }
    } else {
      //Aquí entra cuando desde el listado se selecciona un hotel
      const integrationCode = getHotelIntegrationCode(appConfig.config.hotels, id)
      sessionStorage.setItem('lastSearchCode', integrationCode)
      sessionStorage.setItem('lastSearchType', '0')
    }

    return result
  }

  const getProcessedSearchCoincidences = () => {
    return searchCoincidences.map((group: any) => {
      if (group.category !== 'hotel') return group;

      return {
        ...group,
        items: group.items.map((item: any) => {
          const disabled = isHotelDisabledByConfig(item.id?.toString());

          if (!disabled) return item;

          return {
            ...item,
            component: (
              <Tooltip title={t('components.widget-component.hotel-disabled-by-config')}>
                <span className="hotel-disabled">
                  <ExclamationOutlined style={{ marginRight: 4 }} />
                  {item.label}
                </span>
              </Tooltip>
            )
          };
        })
      };
    });
  };

  // Del historial solo se muestran las búsquedas cuyas fechas no han pasado.
  // Las edades llegan de la API como texto (y pueden venir vacías) y el widget las espera como números
  const userHistory: Array<HistoryItem> = props.userHistory
    .filter((h) => !dayjs(h.dates.from).isBefore(dayjs(), 'day'))
    .map((h) => ({
      ...h,
      occupancy: (h.occupancy ?? []).map((o) => ({
        ...o,
        kids: {
          ...o.kids,
          ages: Object.values(o.kids.ages ?? {})
            .filter((age) => String(age).trim() !== '')
            .map(Number)
        }
      }))
    }))

  // Al pulsar una búsqueda del historial el widget ya autorrellena fechas y habitaciones; aquí se guarda el destino
  const handleSelectHistory = ({ item }: HistoryItem) => {
    // El historial no indica si es hotel o destino: si el código es el de un hotel (igual que en getHotelIntegrationCode), es un hotel
    const hotel = appConfig.config.hotels.find((h) => (h.integrationCode || h.code) === item.id)

    if (hotel && isHotelDisabledByConfig(hotel.code)) {
      notification.warning({
        message: t('components.widget-component.alert'),
        description: t('components.widget-component.hotel-disabled-by-config')
      })
      sessionStorage.removeItem('lastSearchCode')
      sessionStorage.removeItem('lastSearchType')
      sessionStorage.removeItem('lastLabel')
      setDefaultLabel('')
      return
    }

    try {
      ; (document.activeElement as HTMLElement)?.blur()
    } catch { }

    sessionStorage.setItem(
      'lastSearchType',
      (hotel ? EngineDestinationTypeHotel : EngineDestinationTypeLocation).toString()
    )
    sessionStorage.setItem('lastSearchCode', item.id)
    sessionStorage.setItem('lastLabel', item.label)
    setDefaultLabel(item.label)
  }

  const searchConf = {
    history: userHistory,
    list: getProcessedSearchCoincidences(),
    mapObject: (
      <GoogleMaps
        apiKey={
          appConfig.config.scripts.find((script) => script.key === 'google-maps-api-key')?.value
        }
        hotelList={appConfig.config.hotels}
        onSelectedHotel={(item) => { }}
      />
    )
  }

  //Aquí hay un problema y es que cuando se llama a handleSelect el componente se vuelve a refrescar y destination
  //list vuelve a tener el estado inicial y se pierde la selección. Para no rehacer todo el componente se ha guardado el código
  //del país en el sessionStorage.
  const destinationList = {
    category: 'countries',
    elements: countries,
    handleSelectItem: ({ category, selection }: any) => {
      /**NOTA: Este es el método que se invoca cada vez que  se pulsa algo en el listado.*/
      if (category === 'hotels' && isHotelDisabledByConfig(selection.id)) {
        notification.warning({
          message: t('components.widget-component.alert'),
          description: t('components.widget-component.hotel-disabled-by-config')
        });
        return Promise.resolve(null);
      }
      // En hoteles se guarda el integrationCode; el id del listado (code) se sigue usando para handleSelect
      const codeToStore = category === 'hotels'
        ? getHotelIntegrationCode(appConfig.config.hotels, selection.id)
        : selection.id
      sessionStorage.setItem('lastSearchCode', codeToStore)
      return handleSelect(selection.id, category)
    },
    header: <h4>{t('components.widget-component.destinations')}</h4>
  }

  const googleMapsContext = useGoogleMapsContext()

  const onSelectListItem = (item: any) => { }

  const clearSearchItems = () => {
    sessionStorage.removeItem('lastSearchType')
    sessionStorage.removeItem('lastSearchCode')
    sessionStorage.removeItem('lastOccupancy')
    sessionStorage.removeItem('lastRoomType')
    sessionStorage.removeItem('lastLabel')
    sessionStorage.removeItem('selectedCountryCode')
    sessionStorage.removeItem('selectedRegionCode')
    sessionStorage.removeItem('lastFrom')
    sessionStorage.removeItem('lastTo')
    setInitialFrom(null)
    setInitialTo(null)
    setDefaultLabel('')
    cartContext.clearCart()
    bookingEngineContext.clearContext()
  }

  useEffect(() => {
    const googleMapsApiKey = appConfig.config.scripts.find(
      (script) => script.key === 'google-maps-api-key'
    )?.value
    googleMapsContext.initMapScript(googleMapsApiKey)
  }, [])
  useEffect(() => {
    setInitialCountries(availableDestinations)
  }, [availableDestinations])
  useEffect(() => {
    if (props.cleanForm == true) {
      clearSearchItems()
    }
  }, [props.cleanForm])
  useEffect(() => {
    var dateFrom = sessionStorage.getItem('lastFrom')
    var dateTo = sessionStorage.getItem('lastTo')
    var defaultLabel = sessionStorage.getItem('lastLabel')

    if (dateFrom && dateFrom != 'Invalid date') {
      setInitialFrom(dayjs(dateFrom))
    }

    if (dateTo && dateTo != 'Invalid date') {
      setInitialTo(dayjs(dateTo))
    }

    if (defaultLabel) {
      setDefaultLabel(defaultLabel)
    }
  }, [props])

  useEffect(() => {
    console.log()
  }, [])

  function getRoomTypeFromRooms(rooms: any) {
    if (!rooms || rooms.length === 0) return undefined;

    if (rooms.length > 1) return 'multiple';
    if (rooms[0].persons.adults.quantity === 1) return 'single';
    return 'double';
  }



  return (
    <div className="widget-component">
      <WidgetWrapper
        resetFilters={() => bookingEngineContext.updateFilters(clearBookingEngineContext().filters)}
        services={[]}
        regimens={regimens}
        filterButtonAction={bookingEngineContext.updateFilters}
        handleClickRefreshButton={() => clearSearchItems()}
        //   key={initialFrom?.toISOString() + '-' + initualTo?.toISOString()} // si pongo la key esta , provocará que se reinicie eel tipo de habitación al buscar
        defaultLabel={defaultLabel}
        initialFrom={initialFrom ?? null}
        initialTo={initualTo ?? null}
        handleChangeValue={async (value: any) => {
          sessionStorage.setItem('lastLabel', value)
          setDefaultLabel(value)
          onChangeSearchValue(value)
        }}
        map={{
          handleShowMap: (props) => modal.show('map-modal', props),
          closeMap: () => {
            modal.hide()
          },
          items: [hotelUtils.hotel],
          mapKey: 'AIzaSyDIdhJZxHzb9cNHbj_e10MEeRH6zYynVlY'
        }}
        search={searchConf}
        destinationList={destinationList}
        handleClickSearch={function (d): Promise<void> {
          console.log('Datos de la búsqueda en el widget:', d.rooms)
          bookingEngineContext.updateFilters(clearBookingEngineContext().filters)
          sessionStorage.setItem('lastOccupancy', JSON.stringify(d.rooms))

          //Limpiamos el carrito
          cartContext.clearCart()

          var sessionStorageSearchTipe = sessionStorage.getItem('lastSearchType')

          let searchType = sessionStorageSearchTipe
            ? parseInt(sessionStorageSearchTipe)
            : EngineDestinationTypeLocation
          let searchCode = sessionStorage.getItem('lastSearchCode') ?? undefined

          var dateFrom = sessionStorage.getItem('lastFrom')
          var dateTo = sessionStorage.getItem('lastTo')

          var label = sessionStorage.getItem('lastLabel') ?? bookingEngineContext.label

          sessionStorage.setItem('lastRoomType', getRoomTypeFromRooms(d.rooms) ?? 'double');

          let theRooms = d.rooms.map((r: any) => {
            let adults = r.persons.adults.quantity;
            const roomType = sessionStorage.getItem('lastRoomType');



            // Si es doble, limitar a 2
            if (sessionStorage.getItem('lastRoomType') === 'double') {
              adults = Math.min(adults, 2);
            }
            return {
              persons: {
                adults: {
                  quantity: r.persons.adults.quantity,
                  min: r.persons.adults.min,
                  max: r.persons.adults.max
                },
                kids: {
                  ages: r.persons.kids.ages ?? [],
                  quantity: r.persons.kids.quantity,
                  min: r.persons.kids.min,
                  max: r.persons.kids.max
                }
              },
              roomId: r.roomId
            }
          })

          var errorInSearch: boolean = false
          //TODO: Hay que hacer que cuando se selecciona algo venga el code en el widget
          if (!searchCode || searchCode === '') {
            errorInSearch = true
            notification.warning({
              message: t('components.widget-component.alert'),
              description: t('components.widget-component.error-select-destinations')
            })
          } else if (
            dateFrom === null ||
            dateTo === null ||
            dateFrom === 'Invalid date' ||
            dateTo === 'Invalid date' ||
            !moment(dateTo).isValid() ||
            !moment(dateFrom).isValid()
          ) {
            errorInSearch = true
            notification.warning({
              message: t('components.widget-component.alert'),
              description: t('components.widget-component.error-select-dates')
            })
          }

          if (!errorInSearch) {
            let newContext = {
              searchType: searchType,
              searchCode: searchCode,
              promotionalCode: d.code,
              label: label,
              dates: {
                from: dayjs(dateFrom!),
                to: dayjs(dateTo!)
              },
              rooms: theRooms,
              filters: bookingEngineContext.filters
            }


            bookingEngineContext.updateContext(newContext)
            if (window.location.pathname !== GetFormattedUrl('private/booking-engine')) {
              sessionStorage.setItem('lastSearchType', searchType.toString())
              sessionStorage.setItem('lastSearchCode', searchCode!)
              sessionStorage.setItem('lastFrom', dayjs(dateFrom).toString())
              sessionStorage.setItem('lastTo', dayjs(dateTo).toString())
              sessionStorage.setItem('lastOccupancy', JSON.stringify(d.rooms))
              navigate(GetFormattedUrl('private/booking-engine'), {
                state: {
                  redirect: true
                }
              })
              //navigate(GetFormattedUrl(`private/booking-engine?${searchType===EngineDestinationTypeLocation ? 'cc' : 'hc'}=${searchCode}&df=${moment(d.dates.from).format('YYYY-MM-DD')}&dt=${moment(d.dates.to).format('YYYY-MM-DD')}`));
            }
          }

          return Promise.resolve()
        }}
        status={SearchStatus}
        calendar={{
          RelatedItemComponent: RelatedItemComponent,
          ValueComponent: (props) => (
            <div className="app-calendar-pvp-details">{props.price.pvp.toFixed(2)}</div>
          ),
          relatedHotels: [],
          config: { maxDuration: 10, minAntelation: 1, minDuration: 2 },
          // Cuando se lean los datos de los precios diarios desde la API se deben poner en este DATA
          data: [] as any,
          handleInterval: function (interval, status): void {
            //El formato que debe tener la fecha es YYYY-MM-DDTHH:mm:ss.sssZ
            if (interval.from) {
              sessionStorage.setItem(
                'lastFrom',
                `${interval.from.format('YYYY-MM-DDTHH:mm:ss.sssZ')}`
              )
            }
            if (interval.to) {
              sessionStorage.setItem('lastTo', `${interval.to.format('YYYY-MM-DDTHH:mm:ss.sssZ')}`)
            }
          },
          handleUpdateData: function (key: string): Promise<void> {
            console.error('Function not implemented 5.')
            return Promise.resolve()
          }
        }}
        roomType={{
          options: (appConfig?.config?.widget?.availableRoomTypes ?? []) as SelectedRoom[]
        }}
        rooms={{
          // Sirve para especificar los datos de la primera habitación de múltiple
          defaultRoom: {
            persons: {
              adults: {
                quantity: 2,
                min: appConfig?.config?.widget?.minGuestsPerRoom ?? 1,
                max: appConfig?.config?.widget?.maxAdultsPerRoom ?? 4
              },
              kids: {
                quantity: 0,
                min: 0,
                max: appConfig?.config?.widget?.maxChildrenPerRoom ?? 4,
                ages: []
              }
            },
            roomId: 1
          },
          handlePersonsAge: async (roomId, index, value) => { },
          //Método para actualizar la edad de un niño
          handlePersonsAmount: async (type, roomId, value) => { },
          //Método para actualizar la cantidad de personas
          maxGuests: appConfig?.config?.widget?.maxGuestsPerRoom ?? 4,
          minGuests: appConfig?.config?.widget?.minGuestsPerRoom ?? 1,
          maxRooms: appConfig?.config?.widget?.maxRooms ?? 10,
          minRooms: appConfig?.config?.widget?.minRooms ?? 1
        }}
        initialRooms={JSON.parse(sessionStorage.getItem('lastOccupancy') ?? '[]')}
        initialRoomType={sessionStorage.getItem('lastRoomType') as SelectedRoom}
        handleHotelSelection={onSelectListItem}
        handleSelectHistory={handleSelectHistory}
        retrievers={{
          retrieveItemsByName: (v: any) => {
            throw new Error('retrieveItemsByName is not implemented')
          },
          retrieveItemsByCategory: (searchType: any, searchData: any) => {
            if (searchType === 'hotel' && isHotelDisabledByConfig(searchData.id?.toString())) {
              notification.warning({
                message: t('components.widget-component.alert'),
                description: t('components.widget-component.hotel-disabled-by-config')
              });
              sessionStorage.removeItem('lastSearchCode');
              sessionStorage.removeItem('lastSearchType');
              sessionStorage.removeItem('lastLabel');
              setDefaultLabel('');
              return Promise.resolve([]);
            }
            try {
              ; (document.activeElement as HTMLElement)?.blur()
            } catch { }

            sessionStorage.setItem(
              'lastSearchType',
              (searchType == 'hotel'
                ? EngineDestinationTypeHotel
                : EngineDestinationTypeLocation
              ).toString()
            )
            const codeToStore = searchType == 'hotel'
              ? getHotelIntegrationCode(appConfig.config.hotels, searchData.id?.toString())
              : searchData.id
            sessionStorage.setItem('lastSearchCode', codeToStore)

            return Promise.resolve([])
          },
          retrieveItemsById: (v: any) => {
            return Promise.resolve([v])
          }
        }}
      />
    </div>
  )
}

export default WidgetComponent
